<template>
    <!-- <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="displayRecordList" height="61vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceID" label="消毒柜编号" align="center" />
                    <el-table-column prop="startName" label="开始消毒操作人" align="center" />
                    <el-table-column prop="endName" label="结束消毒操作人" align="center" />
                    <el-table-column prop="currentTemp" label="消毒温度上限(℃)" align="center" />
                    <el-table-column prop="target" label="消毒目标" align="center" />
                    <el-table-column prop="date" label="消毒日期" align="center" />
                    <el-table-column prop="startTime" label="开始时间" align="center" />
                    <el-table-column prop="endTime" label="结束时间" align="center" />
                    <el-table-column label="消毒总时长(分钟)" align="center">
                        <template #default="scope">
                            {{ calculateTotalTime(scope.row) }}
                        </template>
</el-table-column>
<el-table-column prop="estimatedTime" label="预计消毒时长(分钟)" align="center" />
<el-table-column prop="status" label="消毒状态" align="center">
    <template #default="scope">
                            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'">
                                {{ scope.row.status === 1 ? '已完成' : '未完成' }}
                            </el-tag>
                        </template>
</el-table-column>
<el-table-column prop="notes" label="消毒备注" align="center" show-overflow-tooltip />
</el-table>


</el-col>
</el-row>
</div> -->
    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">智能消毒柜</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">消毒柜编号</div>
                    <div class="header-item">开始消毒操作人</div>
                    <div class="header-item">结束消毒操作人</div>
                    <div class="header-item">消毒温度上限(℃)</div>

                    <div class="header-item">消毒目标</div>
                    <div class="header-item">消毒日期</div>
                    <div class="header-item">开始时间</div>
                    <div class="header-item">结束时间</div>
                    <div class="header-item">消毒总时长(分钟)</div>
                    <div class="header-item">预计消毒时长(分钟)</div>
                    <div class="header-item">消毒状态</div>
                    <div class="header-item">消毒备注</div>
                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in displayRecordList" :key="index">
                            <div class="body-item">{{ item.deviceID }}</div>
                            <div class="body-item">{{ item.startName }}</div>
                            <div class="body-item">{{ item.endName }}</div>
                            <div class="body-item"> {{ item.currentTemp }}</div>
                            <div class="body-item"> {{ item.target }}</div>
                            <div class="body-item"> {{ item.date }}</div>

                            <div class="body-item"> {{ item.startTime }}</div>
                            <div class="body-item"> {{ item.endTime }}</div>

                            <div class="body-item"> {{ item.estimatedTime }}</div>

                            <div class="body-item"> <el-tag :type="item.status === 1 ? 'success' : 'warning'">
                                    {{ item.status === 1 ? '已完成' : '未完成' }}
                                </el-tag></div>
                            <div class="body-item"> {{ item.notes }}</div>
                        </div>
                        <div class="empty-tip" v-if="displayRecordList.length === 0">
                            暂无信息
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { getRecord } from "@/api/cabinet";
export default {
    data() {
        return {
            // 搜索表单：对齐后端实体字段
            searchForm: {
                deviceID: '',       // 消毒柜编号
                target: '',          // 消毒目标
                status: '',          // 消毒状态
                date: ''             // 消毒日期
            },
            // 原始全量数据（从接口加载）
            allRecordList: [],
            // 筛选后的全量数据
            filteredRecordList: [],
            // 当前页展示的数据
            displayRecordList: [],
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            // 加载状态
            loading: false
        };
    },
    mounted() {
        // 初始化：加载全部数据
        this.getList();
    },
    methods: {
        // 从接口加载数据
        async getList() {
            this.loading = true;
            try {
                const response = await getRecord({ userId: localStorage.getItem('userId') });
                console.log('接口返回数据:', response);

                // 存储原始数据
                this.allRecordList = response.data || [];

                // 初始化筛选（显示全部数据）
                this.filteredRecordList = [...this.allRecordList];

                // 更新总数并分页
                this.totalCount = this.filteredRecordList.length;
                this.paginateData();

                // 无数据提示
                if (this.totalCount === 0) {
                    this.$message.info('暂无消毒记录数据');
                }
            } catch (error) {
                console.error('加载消毒记录失败:', error);
                this.$message.error('加载消毒记录失败，请重试');
                this.allRecordList = [];
                this.filteredRecordList = [];
                this.displayRecordList = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },

        // 处理查询（前端筛选核心逻辑）
        handleSearch() {
            this.loading = true;

            try {
                // 重置页码到第一页
                this.currentPage = 1;

                // 前端筛选逻辑：逐条件过滤全量数据
                this.filteredRecordList = this.allRecordList.filter(item => {
                    // 1. 消毒柜编号筛选（模糊匹配，忽略大小写）
                    if (this.searchForm.deviceID) {
                        const deviceID = (item.deviceID || '').toLowerCase();
                        const searchVal = this.searchForm.deviceID.toLowerCase();
                        if (!deviceID.includes(searchVal)) return false;
                    }

                    // 2. 消毒目标筛选（模糊匹配）
                    if (this.searchForm.target) {
                        const target = (item.target || '').toLowerCase();
                        const searchVal = this.searchForm.target.toLowerCase();
                        if (!target.includes(searchVal)) return false;
                    }

                    // 3. 消毒状态筛选（精确匹配）
                    if (this.searchForm.status !== '') {
                        if (item.status !== Number(this.searchForm.status)) return false;
                    }

                    // 4. 消毒日期筛选（精确匹配）
                    if (this.searchForm.date) {
                        if (item.date !== this.searchForm.date) return false;
                    }

                    // 所有条件都满足
                    return true;
                });

                // 更新总数并分页
                this.totalCount = this.filteredRecordList.length;
                this.paginateData();

                // 无数据提示
                if (this.totalCount === 0) {
                    this.$message.info('未查询到符合条件的消毒记录');
                }
            } catch (error) {
                console.error('筛选数据失败:', error);
                this.$message.error('查询失败，请重试');
            } finally {
                this.loading = false;
            }
        },

        // 分页处理：根据当前页和页大小切割数据
        paginateData() {
            if (this.filteredRecordList.length === 0) {
                this.displayRecordList = [];
                return;
            }

            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayRecordList = this.filteredRecordList.slice(startIndex, endIndex);
        },

        // 重置搜索条件
        resetSearch() {
            // 清空搜索表单
            this.searchForm = {
                deviceID: '',
                target: '',
                status: '',
                date: ''
            };

            // 重置筛选数据为全部数据
            this.filteredRecordList = [...this.allRecordList];
            this.currentPage = 1;
            this.totalCount = this.filteredRecordList.length;
            this.paginateData();

            this.$message.info('搜索条件已重置');
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 重置到第一页
            this.paginateData();
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateData();
        },

        // 计算消毒总时长（分钟）：结束时间 - 开始时间
        calculateTotalTime(row) {
            if (!row.startTime || !row.endTime || !row.date) return '——';

            try {
                // 拼接日期+时间，计算时间差
                const start = new Date(`${row.date} ${row.startTime}`);
                const end = new Date(`${row.date} ${row.endTime}`);

                // 检查日期是否有效
                if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                    return '——';
                }

                const diffMinutes = Math.floor((end - start) / 60000);
                return diffMinutes > 0 ? diffMinutes : '——';
            } catch (error) {
                console.error('计算时长失败:', error);
                return '——';
            }
        },

        // 表格行点击事件（选中/取消选中行）
        handleRowClick(row) {
            this.$refs.tableRef?.toggleRowSelection(row);
        }
    }
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>